module.exports = __webpack_public_path__ + "static/media/homePageIcon.0596752b.svg";